import {
	Delete,
	DownloadOutlined,
	FilePresent,
	VisibilityOutlined,
} from "@mui/icons-material";
import {
	Box,
	Checkbox,
	IconButton,
	MenuItem,
	Stack,
	Typography,
} from "@mui/material";
import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ESRThunkDispatch } from "../../../actions/form";
import getBackendURL from "../../../api/api";
import { download, preview } from "../../../request";
import { ESRState } from "../../../types/data";
import { Layout } from "./Layout";
import { ClowderFile } from "./types";
import { mimeLabels } from "./utils";

type Props = {
	disabled?: boolean;
	file: ClowderFile;
	onDelete: () => void;
};

export const FileItem: FC<Props> = ({ disabled = false, file, onDelete }) => {
	const dispatch = useDispatch<ESRThunkDispatch>();
	const clipboard = useSelector((state: ESRState) => state.clipboard);
	const currentFolder = useSelector((state: ESRState) => state.current_folder);

	const { esrId = "" } = useParams();

	const url = getBackendURL(
		"/esr/attachment/?esr_id=" + esrId + "&file_id=" + file.id,
	);

	return (
		<MenuItem>
			<Layout
				leftActions={
					<Checkbox
						size="small"
						disabled={disabled}
						checked={!!clipboard.find((item) => item.id === file.id)}
						onChange={(e) => {
							e.stopPropagation();
							dispatch({
								type: "UPDATE_CLIPBOARD",
								update: e.target.checked
									? [
											...clipboard,
											{
												type: "file",
												name: file.name,
												id: file.id,
											},
										]
									: clipboard.filter((item) => item.id !== file.id),
							});
						}}
					/>
				}
				icon={<FilePresent />}
				content={
					<Box>
						<Typography
							sx={{
								fontSize: 14,
								fontWeight: 500,
								overflow: "hidden",
								textOverflow: "ellipsis",
							}}
							title={file.name}
						>
							{file.name}
						</Typography>

						<Typography fontSize={12} color="gray" fontWeight={500}>
							{mimeLabels[file.content_type.content_type] ||
								file.content_type.content_type}{" "}
						</Typography>
					</Box>
				}
				rightActions={
					<Stack direction="row">
						<IconButton
							disabled={disabled}
							sx={{ flex: "none" }}
							onClick={() => download(url)}
						>
							<DownloadOutlined />
						</IconButton>
						<IconButton
							disabled={disabled}
							sx={{ flex: "none" }}
							onClick={() => preview(url)}
						>
							<VisibilityOutlined />
						</IconButton>

						{!currentFolder.read_only && (
							<IconButton
								aria-label="delete file"
								color="error"
								disabled={disabled}
								onClick={(e) => {
									e.stopPropagation();
									if (confirm("Are you sure you want to delete?")) {
										onDelete();
									}
								}}
							>
								<Delete />
							</IconButton>
						)}
					</Stack>
				}
				created={file.created}
			/>
		</MenuItem>
	);
};
